import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { API__USER, API__PRODUCTS } from '../../api'
import { USER__SET_SUBSCRIPTION, USER__SET_SUBSCRIPTIONS, PRODUCTS__SET } from '../../store/actions'

export const useProducts = (userId = null) => {
    const { products } = useSelector(state => state)
    const dispatch = useDispatch()

    useEffect(() => {
        const fetch = async () => {
            dispatch(PRODUCTS__SET(await API__PRODUCTS.GET_PAYMENT_PRODUCTS_BY_USER_ID(userId)))
        }

        fetch()
    }, [])

    return products
}

export const useDowngradeAction = () => {
    const { user_details, user_subscription } = useSelector(state => state)
    const dispatch = useDispatch()

    return ({ productCode }) => async () => {
        await API__USER.DOWNGRADE_CURRENT_SUBSCRIPTION(user_subscription.id, productCode)

        dispatch(USER__SET_SUBSCRIPTION(await API__USER.GET_SELECTED_SUBSCRIPTION(user_details.id)))
        dispatch(USER__SET_SUBSCRIPTIONS(await API__USER.GET_SUBSCRIPTIONS(user_details.id)))
    }
}

export const useUserSubscriptions = () => {
    const { user_details, user_subscriptions } = useSelector(state => state)
    const dispatch = useDispatch()

    useEffect(() => {
        const fetch = async () => {
            dispatch(USER__SET_SUBSCRIPTIONS(await API__USER.GET_SUBSCRIPTIONS(user_details.id)))
        }

        if (!user_subscriptions) {
            fetch()
        }
    }, [user_details, user_subscriptions, dispatch])

    return user_subscriptions
}
